import { NavigateFunction } from 'react-router-dom';
import { Appointment } from '../types/Appointment';
import { apiService } from './apiService';
import { format } from 'date-fns';


const AppointmentService = {
    createAppointment: async (data: Appointment, language: string, signal?: AbortSignal) => {
        try {
            const token = sessionStorage.getItem('token') ?? '';
            
            const response = await apiService.post('/appointment/', data, {
                headers: {
                    'Accept-Language': language ?? 'en',
                },
                signal, 
            });

            return response;

        } catch (error: any) {
            console.error("Error in createPatient:", error);

            return {
                message: error.message || "An error occurred while adding the patient.",
                error,
            };
        }
    },

    createAppointmentByBookingLinkId: async (bookingLinkId: string, data: Appointment, language: string, signal?: AbortSignal) => {
        try {

            const response = await apiService.post(`/appointment/by-booking-link-id/${bookingLinkId}/`, data, {
                  headers: {
                    'Accept-Language': language ?? 'en',
                },
                signal,
            });

            return response;

        } catch (error: any) {
            console.error("Error in createPatient:", error);

            return {
                message: error.message || "An error occurred while adding the patient.",
                error,
            };
        }
    },

    getAppointment: async (clinicId: string, startDate: Date, endDate: Date, signal?: AbortSignal, navigate?: NavigateFunction) => {
        try {
            const token = sessionStorage.getItem('token') ?? '';
            const start = encodeURIComponent(format(startDate, 'yyyy-MM-dd'));
            const end = encodeURIComponent(format(endDate, 'yyyy-MM-dd'));

            const response = await apiService.get(`/appointment/${clinicId}?startDate=${start}&endDate=${end}`,{
                    headers: {
                        //'Authorization': `Bearer ${token}`
                    },
                    signal},
                    navigate
                    );

            return response;
        } catch (error: any) {
            if (error.response === 401) {
                throw new Error("Unauthorized: Please log in again.");
            }

            console.error("Error in getAppointment:", error);

            return {
                message: error.message || "An error occurred while getting the appointments.",
                error,
            };
        }
    },
    
    getAppointmentByBookingLinkId: async (bookingLinkId: string, startDate: Date, endDate: Date, signal?: AbortSignal, navigate?: NavigateFunction) => {
        try {
            const token = sessionStorage.getItem('token') ?? '';
            const start = encodeURIComponent(format(startDate, 'yyyy-MM-dd'));
            const end = encodeURIComponent(format(endDate, 'yyyy-MM-dd'));

            const response = await apiService.get(`/appointment/by-booking-link-id/${bookingLinkId}?startDate=${start}&endDate=${end}`, {
                signal
            },
            navigate
        );

            return response;
        } catch (error: any) {

            console.error("Error in getAppointmentByBookingLinkId:", error);

            return {
                message: error.message || "An error occurred while getting the appointments.",
                error,
            };
        }
    },

    updateAppointment: async (appointmentId: string, updateData: any, signal?: AbortSignal) => {
        try {
            const token = sessionStorage.getItem('token') ?? '';
            
            const response = await apiService.patch(`/appointment/${appointmentId}`, updateData, {
                headers: {
                    //'Authorization': `Bearer ${token}`
                },
                signal, 
            });

            return response;
        } catch (error: any) {
            console.error("Error in updatePatient:", error);

            return {
                message: error.message || "An error occurred while updating the patient.",
                error,
            };
        }
    },

    deleteAppointment: async (appointmentId: string, signal?: AbortSignal) => {
        try {
            const token = sessionStorage.getItem('token') ?? '';

            const response = await apiService.delete(`/appointment/${appointmentId}`, {
                headers: {
                    //'Authorization': `Bearer ${token}`
                },
                signal,
            });

            return response;
        } catch (error: any) {
            console.error("Error in updatePatient:", error);

            return {
                message: error.message || "An error occurred while updating the patient.",
                error,
            };
        }
    },

};

export default AppointmentService;
